import React, {useEffect, useRef} from "react";
import {Button, Card, Tabs} from "antd";
import OrderDetailList from "./OrderDetailList";
import {ProfileTwoTone} from "@ant-design/icons";
import {CM_ACTION_TYPE} from "../../../utils/constants";
import OrderForm from "./OrderForm";
import {useModel, useModelDispatchers} from "../../../models";


export default function () {
    const {closeNav} = useModelDispatchers("nav");
    const [{selectedDocument}, {loadDocumentMaterialList}] = useModel("purchaseOrder");

    const formRef = useRef();
    const onSave = () => {
        formRef.current.update();
    }
    const onReset = () => {
        formRef.current.reset();
    }
    const onClose = () => {
        closeNav();
    }
    useEffect(() => {
        if (selectedDocument) {
            loadDocumentMaterialList({showMsg: false, data: selectedDocument.id});
        }
    }, [selectedDocument]);
    const Title = () => {
        return (
            <div style={{display: "flex"}}>
                <h3 style={{flex: "1"}}>
                    <ProfileTwoTone/>
                    <span className="margin-left-8">销售订单</span>
                    <span className="margin-left-16">{selectedDocument.saleOrderCode}</span>
                    <span className="margin-left-16">{selectedDocument.orderStatus}</span>
                </h3>
                <div style={{width: "600px", textAlign: "right"}}>
                    <Button>打印</Button>
                    <Button className="margin-left-8">作废</Button>
                    <Button className="margin-left-8">退货</Button>
                    <Button className="margin-left-8">结算</Button>
                    <Button className="margin-left-8">库房确认</Button>
                    <Button className="margin-left-8" type="primary">保存</Button>
                    <Button className="margin-left-8" onClick={onReset}>重置</Button>
                    <Button className="margin-left-8" onClick={onClose}>关闭</Button>
                </div>
            </div>
        )
    }
    return (
        <Card
            title={<Title/>}
            bordered={true}
            className="margin-top-8"
        >
            <Tabs tabPosition="top">
                <Tabs.TabPane tab="基本信息" key="1">
                    <OrderForm formRef={formRef} actionType={CM_ACTION_TYPE.EDIT}/>
                </Tabs.TabPane>
                <Tabs.TabPane tab="商品明细" key="2">
                    <OrderDetailList/>
                </Tabs.TabPane>

            </Tabs>

        </Card>
    );
}